import type { WatchChange } from '@/services/workspace';

export type Translate = (key: string, options?: Record<string, unknown>) => string;

export function describeChange(change: WatchChange, t: Translate): string {
  const outcomes = (value: unknown) =>
    Array.isArray(value) && value.length > 0
      ? value
          .map((code) =>
            t(`cade:overview.outcomes.${String(code)}`, {
              defaultValue: String(code),
            }),
          )
          .join(', ')
      : t('common:workspace.watch.none');
  if (change.field === 'final_outcomes') {
    return t('common:workspace.watch.final_outcomes', {
      before: outcomes(change.before),
      after: outcomes(change.after),
    });
  }
  return t(`common:workspace.watch.${change.field}`, {
    before: String(change.before),
    after: String(change.after),
  });
}
